import React from 'react';
import styled from 'styled-components';

const Col = styled.div<{ flex: number }>`
  display: flex;
  flex: ${(props) => props.flex};
  flex-direction: row;
  align-items: center;
`;

const ListHeaderDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 48px;
  border-radius: 8px;

  background-color: var(--color-bg-tertiary);
  padding: 0px 8px;
`;

const ListItemWrapper = styled.div`
  height: 48px;
  min-height: 48px;
  width: 100%;
  background-color: var(--color-bg-primary);
  border-bottom: 1px solid var(--color-border-secondary);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 8px;

  .showOnMouseOver {
    visibility: hidden;
  }

  &:hover {
    background-color: var(--color-bg-muted);

    .showOnMouseOver {
      visibility: visible;
    }
  }
`;

const AppUserGridRow = ({
  isHeader,
  NameCol,
  EmailCol,
  FilterValueCol,
  ButtonsCol,
}: {
  isHeader?: boolean;
  NameCol: React.ReactElement;
  EmailCol: React.ReactElement;
  FilterValueCol?: React.ReactElement;
  ButtonsCol?: React.ReactElement;
}) => {
  const WrapperDiv = isHeader ? ListHeaderDiv : ListItemWrapper;
  return (
    <WrapperDiv style={{ gap: 16, padding: '0px 16px' }}>
      <Col flex={5}>{NameCol}</Col>
      <Col flex={4}>{EmailCol}</Col>
      <Col flex={4}>{FilterValueCol}</Col>
      <div style={{ width: 80 }}>{ButtonsCol}</div>
    </WrapperDiv>
  );
};

export default AppUserGridRow;
